// extracted by mini-css-extract-plugin
export default {"container":"TechStack_container__xquvE","darkmode":"TechStack_darkmode__UITrR"};